export default __webpack_public_path__ + "static/media/2022_Ou_et_al_2022_BioScience.f6e3acb2.pdf";